import React from 'react'

const HomePage = () => {
  return (
    <div>WatchPage</div>
  )
}

export default HomePage;